<template>
  <div class="page-full py-4">
    <div class="container">
      <div v-if="step === 2" id="section-to-print">
        <div class="pagebreak">
          <div class="p-3 pl-5">
            <h4 class="mt-3 mb-0 text-danger">
              <b>IMPRIMIR ESTA HOJA ES OBLIGATORIO</b>
            </h4>
            <h6 class="mt-3 mb-0">
              <b>ES OBLIGATORIO IMPRIMIRLA PARA PODER INGRESAR AL ESTADIO</b>
            </h6>
            <div class="position-relative">
              <div>
                <TicketFutbol :item="ticketPrint.participant" />
              </div>
              <p class="text-orientation"><b>ANVERSO</b></p>
            </div>
            <hr>
            <div class="position-relative">
              <TicketText/>
              <p class="text-orientation"><b>REVERSO</b></p>
            </div>
          </div>
        </div>
        <div class="pagebreak">
          <div class="text-center">
            <img src="/images/mapa.jpg" alt="mapa" class="img-fluid">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8 pb-3">
          <div v-if="loading" class="py-5">
            <Loader></Loader>
          </div>
          <TicketList
            :tickets="tickets"
            :participants="participants"
            v-if="step === 1"
            @update="updateAndSendMail($event)"
            @viewTicket="viewTicket($event)"
          ></TicketList>
          <TicketPrint
            :ticketPrint="ticketPrint"
            v-if="step === 2"
            @onGoBack="onGoBack()"
            @sendMailPdf="sendMailPdf($event)"
          ></TicketPrint>
          <div v-if="step === 3">
            <Repayment :tickets="tickets" :infoRepayment="infoRepayment"/>
          </div>
        </div>
        <div class="col-md-4">
          <CardShadow>
            <div class="d-none d-md-block">
              <img src="/images/banners/banner-vert.png" alt="Banner" class="img-fluid">
            </div>
            <div class="d-block d-md-none">
              <img src="/images/banners/banner-hor.png" alt="Banner" class="img-fluid">
            </div>
          </CardShadow>
          <CardShadow>
            <div>
              <img src="/images/banners/banner-dni.png" alt="Banner" class="img-fluid">
            </div>
          </CardShadow>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../api';

export default {
  name: 'tickets',
  data() {
    return {
      step: 1,
      loading: false,
      ticketId: this.$route.params.id,
      ticketPrint: {},
      tickets: [],
      infoRepayment: {},
    };
  },
  created() {
    this.getTickets();
    this.getInfoRepayment();
  },
  computed: {
    participants() {
      if (!this.tickets.length) return [];
      const arr = this.tickets.map(el => el.data.map(item => item.data));
      const redu = arr.reduce((a, b) => a.concat(b));
      return redu.reduce((a, b) => a.concat(b));
    },
  },
  methods: {
    async getTickets() {
      this.loading = true;
      const { ticketId } = this;
      const url = `${api.nodeUrl}/my-tickets`;
      const { data: res } = await api.axios.post(url, { ticketId });
      this.tickets = res;
      this.loading = false;
    },
    viewTicket(data) {
      this.ticketPrint = data;
      this.step = 2;
      window.scroll(0, 0);
    },
    onGoBack() {
      this.step = 1;
    },
    async updateAndSendMail({ email, participant }) {
      await this.getTickets();
      if (!email) return;
      setTimeout(() => {
        const data = this.participants.find(el => el.codeQRId === participant.codeQRId);
        const isCanje = data.paymentMethod === 'transfer' || data.paymentMethod === 'free';
        const emailParticipant = data.email || email;
        const payload = {
          email: isCanje ? emailParticipant : email,
          data: [data],
        };
        if (data.change) {
          this.sendTicketsPdf(payload);
        }
      }, 2000);
    },
    async sendTicketsPdf(payload) {
      const url = '/code-exchange/send-email-tickets';
      await api.axios.post(url, { payload });
    },
    async getInfoRepayment() {
      const data = await api.getInfoRepayment(this.ticketId);
      if (data.success && data.data.activity.state === 2) {
        this.infoRepayment = { ...data.data };
        this.step = 3;
      }
    },
  },
};
</script>
